import styles from './BestPerformers.module.scss'
import { Video } from 'components/basic/Video'

interface BestPerformerCardProps {
	videoSrc: string
	videoThumb: string
	quote: string
	quoteAuthor: string
}

export const BestPerformerCard = (props: BestPerformerCardProps) => {
	return (
		<>
			<div className={styles.media_container}>
				<Video
					src={props.videoSrc}
					caption={''}
					thumb={props.videoThumb}
					playIcon="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes/play-button.svg"
					controlsOnPlay={true}
					showControls={true}
					autoplay={false}
					muted={false}
				/>
			</div>

			<div className={styles.performer_content_container}>
				<div className={styles.performer_content_title_container}>
					<div className={styles.performer_content_title}>{props.quote}</div>
					<div className={styles.performer_content_subtitle}>{props.quoteAuthor}</div>
				</div>
			</div>
		</>
	)
}
